import { render, staticRenderFns } from "./EditVideo.vue?vue&type=template&id=7ef11706&scoped=true&"
import script from "./EditVideo.vue?vue&type=script&lang=ts&"
export * from "./EditVideo.vue?vue&type=script&lang=ts&"
import style0 from "./EditVideo.vue?vue&type=style&index=0&id=7ef11706&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef11706",
  null
  
)

export default component.exports